<app-toaster class="toaster" [config]="toastService.toaster"></app-toaster>
<filter-pane [filterComponents]="filterComponents" [showFilter]="showFilters"
  (change)="onFilterChange($event)" (submit)="applyFilters($event)"></filter-pane>
<div>
  <mat-toolbar class="toolbar-border">
    Configured Limits
    <div class="pull-right is-flex" style="height: 35px;">
      <input type="text" class="filter-button filter-input-box" [(ngModel)]="searchText"
        (change)="applySearch()" placeholder="Search limits">
      <button mat-raised-button class="btn-primary" (click)="showFilters = !showFilters">Filters</button>
    </div>
  </mat-toolbar>
  <data-table [table]="table" (paginationChange)="renderPage()" (headerToSort)="sortByHeader($event)"></data-table>
  <app-authz-access-hint-footer [authzAccessHint]="authzAccessHint"></app-authz-access-hint-footer>
</div>
